/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsPipeline {
    getFixupPrototypeFunction() { return AzureDevOpsPipeline.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsPipeline>): AzureDevOpsPipeline {
        let obj = Object.assign(new AzureDevOpsPipeline(), model);
        AzureDevOpsPipeline.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsPipeline>): AzureDevOpsPipeline {
        if (!model) return null;
        return AzureDevOpsPipeline.newInstance(<AzureDevOpsPipeline> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsPipeline) {
        if (!obj) return;

        models.AzureDevOpsPipeline.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsPipeline): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsPipeline.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pipeline_id === undefined) {
            this.pipeline_id = 0;
        }
    }

    /**
     * Azure DevOps Pipeline ID
     */
    pipeline_id: number;

    /**
     * Azure DevOps Pipeline Name
     */
    pipeline_name: string;

}
